import api from './axiosService';

export const appApi = {
    getOverview(params = {}) {
        return api.get('/app-overview', { params });
    },

    getOwnerDashboard(params = {}) {
        return api.get('/dashboard/owner', { params });
    },

    getSellerDashboard(params = {}) {
        return api.get('/dashboard/seller', { params });
    },
};